import React, { Component, Fragment } from "react";
import { Col, Row } from "reactstrap";
import { TopSubNavigationList } from "../Common/SideSubNavigation";
import ActivitiesList from "./ActivitiesList";
import DayTimesheet from "./DayTimesheet";
import EntryTemplates from "./EntryTemplates";
import HosLocationManager from "./HosLocationManager";
import MyHoursOfService from "./MyHoursOfService";
import { CRUDFunction } from "../../reduxCURD/container";
import SpinnerLoader from "../Common/SpinnerLoader";
import { FixedAppLookupsContext } from "../FixedAppLookupsProvider";
import ReportOffDuty from "./ReportOffDuty";
import HosUsers from "./HosUsers";
import HosReport from "./HosReport";
import permissionCheck from "../../utils/permissionCheck";
import MobileAppView from "../MobileAppView";
import TopMessageBar from "../../libraries/TopMessageBar";
import moment from "moment";
import { dataFormatters } from "../../utils/dataFormatters";
import HOSStatusView from "./HOSStatusView";
import { Redirect, Route, Switch } from "react-router-dom";
import { StateRetentionContext } from "../StateRetentionProvider";
import { isFraRole } from "../MainPage/UserInfo";
import HosViolationReport from "./HosViolationReport";
import MistakenHosReport from "./HosMistakenReport";
import { languageService } from "../../Language/language.service";
const CONFIGURE_HOS_MESSAGE = languageService("Please configure the Start Date for HOS");
const SELECT_TIMEZONE_HOS_MESSAGE = languageService("Please select the Time zone in order to proceed!");

const generalSideNavOp = [
  { id: "MyHoursOfService", path: "/my-hours-of-service", value: "My Hours of Service" },
  { id: "ReportOffDuty", path: "/report-off-duty", value: "Report Off Duty" },
  // { id: "DayTimesheet", path: "/DayTimesheet", value: "Day Timesheet" },
  { id: "LocationManager", path: "/location-manager", value: "Location Manager", resource: "HOS", action: "setup", check: true }, // Allowed to the admin only
  { id: "ActivitiesList", path: "/activities-list", value: "Activities List", resource: "HOS", action: "setup", check: true },
  { id: "EntryTemplates", path: "/entry-templates", value: "Templates" },
  { id: "HosUsers", path: "/configure-users", value: "Configure Users", resource: "HOS", action: "setup", check: true }, // Allowed to the admin only
  { id: "HOSStatusView", path: "/status-view", value: "HOS Status" },
  { id: "HosReport", path: "/search-reports", value: "Search Reports" },
  { id: "HosViolationReport", path: "/violation-reports", value: languageService("Non-Compliance") },
  { id: "MistakenHosReport", path: "/mistaken-reports", value: languageService("Search Mistaken Reports") },
];

const fraSideNavOp = [
  { id: "HosReport", path: "/search-reports", value: "Search Reports" },
  { id: "HosViolationReport", path: "/violation-reports", value: languageService("Non-Compliance") },
  { id: "MistakenHosReport", path: "/mistaken-reports", value: languageService("Search Mistaken Reports") },
];

export const HoursOfServiceSubSideNavOptions = isFraRole() ? [...fraSideNavOp] : [...generalSideNavOp];

class HoursOfService extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSideNavOption: HoursOfServiceSubSideNavOptions[0],
      showloader: false,
      userHosInfo: null,
    };
  }

  componentDidMount() {
    moment.tz.setDefault();
    const { getHosData } = this.props;
    getHosData && getHosData("getUserHosInfo");
  }

  componentDidUpdate(prevProps, prevState) {
    const { actionType, HosData, getHosData } = this.props;
    if (actionType !== prevProps.actionType) {
      if (actionType === "HOSDATA_READ_REQUEST" || actionType === "HOSDATA_UPDATE_REQUEST") {
        this.setShowLoader(true);
      } else if (actionType === "HOSDATA_READ_SUCCESS") {
        if (HosData && HosData.userHos) {
          let userHosInfo = HosData.userHos;
          const { timezone, startDate } = userHosInfo;
          startDate && timezone && (userHosInfo.startDate = dataFormatters.getDateFromStringWithTimezone(startDate, timezone));
          if (timezone) {
            moment.tz.setDefault(timezone);
          } else {
            moment.tz.setDefault();
          }
          // received user hos info
          this.setState({
            userHosInfo: userHosInfo,
          });
        }
        this.setShowLoader(false);
      } else if (actionType === "HOSDATA_UPDATE_SUCCESS") {
        getHosData && getHosData("getUserHosInfo");
        this.setShowLoader(false);
      } else if (actionType === "HOSDATA_READ_FAILURE" || actionType === "HOSDATA_UPDATE_FAILURE") {
        this.setShowLoader(false);
      }
    }
  }
  componentWillUnmount() {
    moment.tz.setDefault();
  }
  setShowLoader(status) {
    this.setState({ showloader: status });
  }
  render() {
    const { getHosData, updateHosData, mobileView } = this.props;
    const { isValidHosLocation } = this.context;
    const { userHosInfo } = this.state;
    const timezone = userHosInfo && userHosInfo.timezone;
    const effectiveDate = userHosInfo && userHosInfo.startDate;
    const myHq = userHosInfo && isValidHosLocation(userHosInfo.HQ) ? userHosInfo.HQ : null; // check if this location still exists in the lookup
    const hosEnabled = effectiveDate ? true : false;

    const basePath = mobileView ? "/appHos" : "/hos";

    const secondBasePath = isFraRole() ? "search-reports" : "my-hours-of-service";
    return (
      <StateRetentionContext.Consumer>
        {(stateRetention) => (
          <div className="location-selection-main site mainContent" style={{ backgroundColor: "rgb(227,233,239)" }}>
            <SpinnerLoader spinnerLoading={this.state.showloader} />
            <Fragment>
              <TopSubNavigationList
                currPath={this.props.location.pathname}
                items={HoursOfServiceSubSideNavOptions.filter(
                  (option) => !option.check || permissionCheck(option.resource, option.action),
                ).map((option) => ({ ...option, path: `${basePath}${option.path}` }))}
                onClick={(path) => {
                  stateRetention.setLastSubNavTab("hoursOfService", path);
                }}
              />
              <Row>
                <Col>
                  <Switch>
                    <Route
                      exact
                      path={`${basePath}/report-off-duty`}
                      render={() =>
                        hosEnabled ? (
                          timezone ? (
                            <ReportOffDuty timezone={timezone} effectiveDate={effectiveDate} />
                          ) : (
                            <TopMessageBar message={SELECT_TIMEZONE_HOS_MESSAGE} type={"Info"} />
                          )
                        ) : (
                          <TopMessageBar message={CONFIGURE_HOS_MESSAGE} type={"Info"} />
                        )
                      }
                    />
                    <Route path={`${basePath}/DayTimesheet`} render={() => <DayTimesheet />} />
                    <Route
                      exact
                      path={`${basePath}/location-manager`}
                      render={() =>
                        hosEnabled ? (
                          <HosLocationManager hq={myHq} makeHq={(newHq) => updateHosData && updateHosData({}, `setHQ/${newHq}`)} />
                        ) : (
                          <TopMessageBar message={CONFIGURE_HOS_MESSAGE} type={"Info"} />
                        )
                      }
                    />
                    <Route
                      exact
                      path={`${basePath}/activities-list`}
                      render={() => (hosEnabled ? <ActivitiesList /> : <TopMessageBar message={CONFIGURE_HOS_MESSAGE} type={"Info"} />)}
                    />
                    <Route
                      exact
                      path={`${basePath}/search-reports`}
                      render={(routeProps) => (
                        <HosReport
                          effectiveDate={effectiveDate}
                          {...routeProps}
                          stateRetention={{
                            ...stateRetention.hoursOfService.searchReports,
                            set: stateRetention.setHosReportValue,
                          }}
                        />
                      )}
                    />
                    <Route
                      exact
                      path={`${basePath}/mistaken-reports`}
                      render={(routeProps) => (
                        <MistakenHosReport
                          {...routeProps}
                          stateRetention={{
                            ...stateRetention.hoursOfService.mistakenHosReports,
                            set: stateRetention.setMistakenReportValue,
                          }}
                        />
                      )}
                    />
                    <Route
                      exact
                      path={`${basePath}/violation-reports`}
                      render={(routeProps) => (
                        <HosViolationReport
                          effectiveDate={effectiveDate}
                          {...routeProps}
                          stateRetention={{
                            ...stateRetention.hoursOfService.searchViolationReports,
                            set: stateRetention.setHosViolationReportValue,
                          }}
                        />
                      )}
                    />
                    <Route
                      exact
                      path={`${basePath}/configure-users`}
                      render={() => <HosUsers getMyLatestHosInfo={() => getHosData && getHosData("getUserHosInfo")} />}
                    />
                    <Route exact path={`${basePath}/status-view`} render={() => <HOSStatusView />} />
                    <Route
                      exact
                      path={`${basePath}/entry-templates`}
                      render={() =>
                        hosEnabled ? (
                          timezone ? (
                            <EntryTemplates hq={myHq} effectiveDate={effectiveDate} timezone={timezone} />
                          ) : (
                            <TopMessageBar message={SELECT_TIMEZONE_HOS_MESSAGE} type={"Info"} />
                          )
                        ) : (
                          <TopMessageBar message={CONFIGURE_HOS_MESSAGE} type={"Info"} />
                        )
                      }
                    />
                    <Route
                      exact
                      path={`${basePath}/${secondBasePath}`}
                      render={() =>
                        hosEnabled ? (
                          timezone ? (
                            <MyHoursOfService
                              hq={myHq}
                              effectiveDate={effectiveDate}
                              timezone={timezone}
                              stateRetention={{
                                ...stateRetention.hoursOfService.myHoursOfService,
                                set: (key, val) => stateRetention.setHosTabState("myHoursOfService", key, val),
                              }}
                            />
                          ) : (
                            <TopMessageBar message={SELECT_TIMEZONE_HOS_MESSAGE} type={"Info"} />
                          )
                        ) : (
                          <TopMessageBar message={CONFIGURE_HOS_MESSAGE} type={"Info"} />
                        )
                      }
                    />
                    <Route
                      path={basePath}
                      render={() => (
                        <Redirect
                          to={
                            stateRetention.hoursOfService.lastSubNavTab
                              ? stateRetention.hoursOfService.lastSubNavTab
                              : `${basePath}/${secondBasePath}`
                          }
                        />
                      )}
                    />
                  </Switch>
                </Col>
              </Row>
            </Fragment>
          </div>
        )}
      </StateRetentionContext.Consumer>
    );
  }
}

HoursOfService.contextType = FixedAppLookupsContext;

let variableList = {};
let reducers = [];

let actionOptions = {
  read: true,
  create: false,
  update: true,
  delete: false,
  others: {},
};

const HoursofServiceContainer = CRUDFunction(HoursOfService, "HosData", actionOptions, variableList, reducers, "hoursofservice");

export const HoursofServiceContainerMobileAppView = (props) => (
  <MobileAppView>
    <HoursofServiceContainer mobileView={true} {...props} />
  </MobileAppView>
);

export default HoursofServiceContainer;



// WEBPACK FOOTER //
// ./src/components/HoursOfService/index.jsx